import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject, Subscription } from "rxjs/Rx";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { debounceTime } from "rxjs/operator/debounceTime";
import { LoaderService } from "../shared/services/loader.service";
import { BackendService } from "../shared/services/backend.service";
import { PollService } from "../shared/services/poll/poll.service";
import { Poll } from "../shared/services/poll/poll";
import * as firebase from "firebase/app";
import { AccountService } from "../shared/account/account.service";
import { AuthService } from "../shared/services/auth.service";

@Component({
  selector: "app-polls",
  templateUrl: "./polls.component.html",
  styleUrls: ["./polls.component.css"]
})
export class PollsComponent implements OnInit, OnDestroy {
  private routeSubscription: Subscription = new Subscription();
  private _alert: Subject<string> = new Subject<string>();
  private alertSubscription: Subscription = new Subscription();
  activeRouteIndex: number;
  modalReference: NgbModalRef;
  query: string;
  page = 1;
  polls;
  poll: Poll;
  title: string;
  description: string;
  duration: number;
  pollName: string;
  confirmationMessage = "";
  confirmationTitle = "";
  pageSuccessMessage: string;
  pageErrorMessage: string;
  modalSuccessMessage: string;
  modalErrorMessage: string;
  option;
  addedOptions: Array<any>;
  private authState: firebase.User | null;
  communityId: string;
  userId: string;
  now = Date.now();

  constructor(
    private accountService: AccountService,
    private authService: AuthService,
    private modalService: NgbModal,
    private loaderService: LoaderService,
    private pollService: PollService,
    private route: ActivatedRoute
  ) {
    this.addedOptions = [];
    this.poll = new Poll();
    this.userId = BackendService.generateUserId(
      this.authService.getAuthState().email
    );
  }

  ngOnInit(): void {
    this.loaderService.startLoader();
    this.routeSubscription = this.accountService
      .getProfile(this.userId)
      .subscribe((profile: any) => {
        this.route.params.subscribe(params => {
          this.activeRouteIndex = +params.index;
          const activeRole: any = profile.roles[this.activeRouteIndex];
          this.communityId = activeRole.communityId;
          this.polls = this.pollService.getPolls(this.communityId);
        });
      });
    this.loaderService.stopLoader();
  }

  createPoll(modal): void {
    this.openModal(modal, "md");
  }

  addOption(): void {
    if (this.option !== "") {
      for (const addedOption of this.addedOptions) {
        if (addedOption === this.option) {
          const msgType = false;
          const msg = "That option has been added already.";
          this.showAlertInModal(msgType, msg);

          return;
        }
      }
      this.addedOptions.push(this.option);
      this.option = "";
    }
  }

  removeOption(index): void {
    this.addedOptions.splice(index, 1);
  }

  confirmDelete(poll: any, modal): void {
    this.poll = poll;
    this.pollName = this.poll["title"];
    this.confirm(modal);
  }

  deletePoll(): void {
    this.pollService.delete(this.poll)
    .then(result => this.resultNotification("deleted", result));
  }

  confirm(modal): void {
    this.openModal(modal, "sm");
  }

  openModal(modal, modalSize): void {
    this.modalReference = this.modalService.open(modal, { size: modalSize });
  }

  closeModal(): void {
    if (this.modalReference) {
      this.modalReference.close();
    }
  }

  showAlertonPage(msgType, msg): void {
    this.alertSubscription = this._alert.subscribe(
      message =>
        msgType
          ? (this.pageSuccessMessage = message)
          : (this.pageErrorMessage = message)
    );
    debounceTime
      .call(this._alert, 4000)
      .subscribe(
        () =>
          msgType
            ? (this.pageSuccessMessage = undefined)
            : (this.pageErrorMessage = undefined)
      );
    this._alert.next(msg);
    this.alertSubscription.unsubscribe();
  }

  showAlertInModal(msgType, msg): void {
    this.alertSubscription = this._alert.subscribe(
      message =>
        msgType
          ? (this.modalSuccessMessage = message)
          : (this.modalErrorMessage = message)
    );
    debounceTime
      .call(this._alert, 3000)
      .subscribe(
        () =>
          msgType
            ? (this.modalSuccessMessage = undefined)
            : (this.modalErrorMessage = undefined)
      );
    this._alert.next(msg);
    this.alertSubscription.unsubscribe();
  }

  isNumber(event: any): boolean {
    const charCode = event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

    return true;
  }

  savePoll(): void {
    this.poll = this.generatePollObject();
    this.pollService.create(this.poll)
      .then(result => {
        this.resultNotification("saved", result);
        this.clearFields();
      });
  }

  clearFields(): void {
    this.title = "";
    this.description = "";
    this.option = undefined;
    this.addedOptions = [];
    this.duration = undefined;
  }
  generatePollObject(): {} {
    const optionObject = this.addedOptions.reduce((tally, vote) => {
      tally[vote] = 0;

      return tally;
    }, {});

    return {
      title: this.title,
      description: this.description || "",
      expiryDate: new Date().setDate(new Date().getDate() + this.duration),
      options: optionObject,
      createdAt: Date.now(),
      operatorId: this.userId,
      communityId: this.communityId,
      voteCount: 0
    };
  }

  resultNotification(action, result): void {
    if (typeof (result) === "undefined") {
      this.closeModal();
      this.showAlertonPage(true, `Poll ${action} successfully.`);
    } else {
      this.closeModal();
      this.showAlertonPage(
        false,
        `Something went wrong. Poll could not be ${action}.`
      );
    }
  }

  ngOnDestroy(): void {
    this.closeModal();
  }
}



// WEBPACK FOOTER //
// ./src/app/polls/polls.component.ts